/* ShedAutos.pk — Theme JS v2 */
'use strict';

// ── Utility ──────────────────────────────────────────────────────────────
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

// ── CSS var: --header-h ──────────────────────────────────────────────────
function updateHeaderH() {
  const topbarH = $('.topbar')?.offsetHeight || 0;
  const headerH = $('.header')?.offsetHeight || 0;
  document.documentElement.style.setProperty('--header-h', (topbarH + headerH) + 'px');
}
window.addEventListener('resize', updateHeaderH, { passive: true });
document.addEventListener('DOMContentLoaded', updateHeaderH);

// ── Header scroll ────────────────────────────────────────────────────────
(function headerScroll() {
  const header = $('.header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('header--scrolled', window.scrollY > 20);
  }, { passive: true });
})();

// ── Mobile navigation ───────────────────────────────────────────────────
(function mobileMenu() {
  const toggle = document.getElementById('shed-menu-toggle');
  const drawer = document.getElementById('shed-mobile-drawer');
  if (!toggle || !drawer) return;

  const setMenuState = (open) => {
    drawer.classList.toggle('is-open', open);
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };

  toggle.addEventListener('click', () => setMenuState(!drawer.classList.contains('is-open')));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) setMenuState(false);
  });

  $$('.shed-md-toggle', drawer).forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.target);
      if (!target) return;
      const open = target.hidden;
      target.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.querySelector('.md-arrow')?.classList.toggle('rotated', open);
    });
  });
})();

// ── Shopify Cart API ────────────────────────────────────────────────────
const Cart = {
  async request(url, options = {}) {
    const response = await fetch(url, {
      headers: { Accept: 'application/json', ...options.headers },
      ...options
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed.');
    return data;
  },
  get() { return this.request('/cart.js'); },
  add(id, quantity = 1) {
    return this.request('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity })
    });
  },
  change(id, quantity) {
    return this.request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity })
    });
  },
  remove(id) { return this.change(id, 0); }
};

function formatMoney(cents) {
  return 'PKR ' + (Number(cents || 0) / 100).toLocaleString('en-PK', { maximumFractionDigits: 0 });
}

function updateCartBadge(count) {
  $$('.icon-btn .badge').forEach((badge) => {
    badge.textContent = count;
    badge.hidden = count <= 0;
  });
}

function renderCartDrawer(cart) {
  const body = $('#cart-drawer-body');
  const total = $('#cart-drawer-total');
  if (!body) return;

  if (!cart.item_count) {
    body.innerHTML = '<div class="cart-empty"><div class="cart-empty__title">YOUR CART IS EMPTY</div><a href="/collections/all" class="btn btn-yellow">SHOP NOW</a></div>';
  } else {
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <div class="img" style="background-image:url('${item.image || ''}')"></div>
        <div>
          <div class="meta">${item.vendor || ''}</div>
          <div class="name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="meta">${item.variant_title}</div>` : ''}
          <div class="qty">
            <button type="button" class="qty-minus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" class="qty-plus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div>
          <div class="price">${formatMoney(item.line_price)}</div>
          <button type="button" class="remove-item" data-key="${item.key}">REMOVE</button>
        </div>
      </div>`).join('');
  }

  if (total) total.textContent = formatMoney(cart.total_price);
}

async function refreshCart() {
  const cart = await Cart.get();
  updateCartBadge(cart.item_count);
  renderCartDrawer(cart);
  return cart;
}

(function cartDrawer() {
  const overlay = $('#cart-overlay');
  const drawer = $('#cart-drawer');
  const closeButton = $('.drawer-close', drawer);
  if (!drawer) return;

  const setDrawerState = async (open, refresh = false) => {
    overlay?.classList.toggle('open', open);
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('cart-open', open);
    if (open && refresh) {
      try { await refreshCart(); } catch (error) { console.error('Unable to refresh cart:', error); }
    }
  };

  window.openCart = () => setDrawerState(true, true);
  window.closeCart = () => setDrawerState(false);

  $$('.cart-trigger').forEach((button) => on(button, 'click', () => window.openCart()));
  on(overlay, 'click', () => window.closeCart());
  on(closeButton, 'click', () => window.closeCart());

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('open')) window.closeCart();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.qty-minus, .qty-plus, .remove-item');
    if (!button) return;
    event.preventDefault();
    try {
      if (button.classList.contains('remove-item')) await Cart.remove(button.dataset.key);
      else {
        const current = Number(button.dataset.qty || 1);
        const quantity = button.classList.contains('qty-plus') ? current + 1 : Math.max(0, current - 1);
        await Cart.change(button.dataset.key, quantity);
      }
      await refreshCart();
    } catch (error) {
      console.error('Cart update failed:', error);
      alert(error.message || 'Unable to update your cart. Please try again.');
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = Math.max(1, Number(formData.get('quantity') || 1));
    if (!id) return;
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    try {
      if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
      await Cart.add(id, quantity);
      await setDrawerState(true, true);
    } catch (error) {
      console.error('Add to cart failed:', error);
      alert(error.message || 'Unable to add this item to your cart.');
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.quick-add-btn');
    if (!button) return;
    event.preventDefault();
    const id = button.dataset.variantId;
    if (!id) return;
    const original = button.textContent;
    try {
      button.disabled = true; button.textContent = 'ADDING…';
      await Cart.add(id, 1);
      await setDrawerState(true, true);
    } catch (error) {
      console.error('Quick add failed:', error);
      alert(error.message || 'Unable to add this item to your cart.');
    } finally {
      button.disabled = false; button.textContent = original;
    }
  });
})();

// ── FAQ accordion ────────────────────────────────────────────────────────
(function faq() {
  $$('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      $$('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
})();

// ── Services tabs ────────────────────────────────────────────────────────
(function servicesTabs() {
  const tabs = $$('.svc-tab');
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      // Switch tab active states
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Switch panels
      $$('.svc-panel').forEach(p => {
        const isTarget = p.dataset.panel === target;
        p.classList.toggle('active', isTarget);
      });

      // Scroll to tabs on mobile
      const wrap = document.querySelector('.svc-tabs-wrap');
      if (wrap) {
        const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 96;
        const top = wrap.getBoundingClientRect().top + window.scrollY - headerH;
        window.scrollTo({ top, behavior: 'smooth' });
      }

      // GSAP re-animate if available
      if (typeof gsap !== 'undefined') {
        const activePanel = document.querySelector(`.svc-panel[data-panel="${target}"]`);
        if (activePanel) {
          const cards = activePanel.querySelectorAll('.pkg-card, .coating-card');
          if (cards.length) {
            gsap.fromTo(cards, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.55, stagger: 0.08, ease: 'power2.out' });
          }
        }
      }
    });
  });

  // Handle URL hash on load (e.g. /pages/services?tab=coatings)
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam  = urlParams.get('tab') || window.location.hash.replace('#', '');
  if (tabParam && ['detailing','coatings','ppf'].includes(tabParam)) {
    const targetTab = document.querySelector(`.svc-tab[data-tab="${tabParam}"]`);
    if (targetTab) targetTab.click();
  }
})();

// ── Car category price calculator ───────────────────────────────────────
(function carCalc() {
  const mults = { hatch: 1, lhatch: 1.15, sedan: 1.25, lsedan: 1.4, cross: 1.55, suv: 1.75 };
  const labels = { hatch: 'Hatchback', lhatch: 'Long Hatch', sedan: 'Sedan', lsedan: 'Long Sedan', cross: 'Crossover', suv: 'SUV' };

  function applyCarCalc(chip) {
    const carId = chip.dataset.car;
    const mult  = mults[carId] || 1;
    const label = labels[carId] || carId;

    // Find the parent panel (svc-panel) or whole page to scope updates
    const scope = chip.closest('.svc-panel') || document;

    $$('.pkg-price-val', scope).forEach(el => {
      const base = parseInt(el.dataset.base || '0');
      el.textContent = Math.round(base * mult).toLocaleString();
    });
    $$('.pkg-car-label', scope).forEach(el => {
      const prefix = el.textContent.includes('FULL BODY') ? 'FULL BODY / ' : 'FROM / ';
      el.textContent = prefix + label.toUpperCase();
    });
    $$('.book-price-val', scope).forEach(el => {
      const base = parseInt(el.dataset.base || '0');
      el.textContent = 'PKR ' + Math.round(base * mult).toLocaleString();
    });
    $$('.book-total-val', scope).forEach(el => {
      const base = parseInt(el.dataset.base || '0');
      el.textContent = 'PKR ' + Math.round(base * mult).toLocaleString();
    });
    $$('.pkg-car-label-text', scope).forEach(el => {
      el.textContent = label;
    });
  }

  // Group car selectors by their parent panel
  $$('.car-selector').forEach(selector => {
    const chips = $$('.car-chip', selector);
    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        applyCarCalc(chip);
        // Also sync any select dropdown nearby
        const sel = document.querySelector('.car-selector-select');
        if (sel) sel.value = chip.dataset.car;
      });
    });
  });

  // Car select dropdown on detail pages
  $$('.car-selector-select').forEach(sel => {
    sel.addEventListener('change', () => {
      const chip = document.querySelector(`.car-chip[data-car="${sel.value}"]`);
      if (chip) chip.click();
    });
  });
})();

// ── Interior tab toggle (services page) ─────────────────────────────────
(function intTab() {
  $$('.int-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.intTab;
      // Scope to the parent detailing panel
      const panel = btn.closest('.svc-panel') || document;
      $$('.int-tab', panel).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      $$('.int-panel', panel).forEach(p => {
        p.classList.toggle('active', p.dataset.intPanel === target);
      });
    });
  });
})();

// ── Product image thumbnails ─────────────────────────────────────────────
(function productImages() {
  const mainImg = $('.pd-img-inner');
  if (!mainImg) return;
  $$('.pd-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      $$('.pd-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.dataset.src;
      if (src) mainImg.style.backgroundImage = `url(${src})`;
    });
  });
})();

// ── Qty controls (product page) ──────────────────────────────────────────
(function qtyControls() {
  $$('.qty-ctrl').forEach(ctrl => {
    const inp  = ctrl.querySelector('.qty-input, input[name="quantity"]');
    const plus = ctrl.querySelector('[data-action="plus"]');
    const minus= ctrl.querySelector('[data-action="minus"]');
    if (!inp) return;
    plus?.addEventListener('click',  () => { inp.value = Math.max(1, parseInt(inp.value || 1) + 1); });
    minus?.addEventListener('click', () => { inp.value = Math.max(1, parseInt(inp.value || 1) - 1); });
  });
})();

// ── Collection filter chips ──────────────────────────────────────────────
(function filterChips() {
  $$('.filter-chips .fchip[data-tag]').forEach(chip => {
    chip.addEventListener('click', () => {
      const tag = chip.dataset.tag;
      if (!tag) return;
      const url = new URL(window.location.href);
      if (tag === 'all') {
        url.searchParams.delete('filter.p.tag');
        url.searchParams.delete('q');
      } else {
        url.searchParams.set('filter.p.tag', tag);
      }
      window.location.href = url.toString();
    });
  });
})();

// ── Price filter ─────────────────────────────────────────────────────────
(function priceFilter() {
  const minInput = document.getElementById('price-min');
  const maxInput = document.getElementById('price-max');
  if (!minInput || !maxInput) return;

  function applyPriceFilter() {
    const min = parseInt(minInput.value) || 0;
    const max = parseInt(maxInput.value) || 99999999;
    const url = new URL(window.location.href);
    if (min > 0) url.searchParams.set('filter.v.price.gte', min * 100);
    else url.searchParams.delete('filter.v.price.gte');
    if (max < 99999999) url.searchParams.set('filter.v.price.lte', max * 100);
    else url.searchParams.delete('filter.v.price.lte');
    window.location.href = url.toString();
  }

  [minInput, maxInput].forEach(inp => {
    inp.addEventListener('keydown', e => { if (e.key === 'Enter') applyPriceFilter(); });
  });
})();

// ── WhatsApp booking form ────────────────────────────────────────────────
(function waBooking() {
  $$('.wa-booking-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const waNum = window.theme?.whatsapp || '923313376680';
      const service = form.querySelector('[name="service"]')?.value || '';
      const car     = form.querySelector('[name="car"]')?.value || 'Sedan';
      const name    = form.querySelector('[name="name"]')?.value || '';
      const phone   = form.querySelector('[name="phone"]')?.value || '';
      const city    = form.querySelector('[name="city"]')?.value || '';
      const date    = form.querySelector('[name="date"]')?.value || '';
      const notes   = form.querySelector('[name="notes"]')?.value || '';
      const msg = encodeURIComponent(
        `Hello ShedAutos!\n\nI'd like to book:\n\n` +
        `Service: ${service}\nCar: ${car}\n` +
        `Name: ${name}\nPhone: ${phone}\nCity: ${city}\n` +
        `${date ? 'Date: ' + date + '\n' : ''}` +
        `${notes ? 'Notes: ' + notes : ''}`
      );
      window.open(`https://wa.me/${waNum}?text=${msg}`, '_blank');
    });
  });
})();

// ── GSAP Animations ──────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  // ── Hero animations ──
  const heroH1Spans = $$('.hero h1 .split-word');
  if (heroH1Spans.length) {
    heroH1Spans.forEach(span => {
      const text = span.textContent;
      span.innerHTML = text.split('').map(ch =>
        ch === ' ' ? ' ' : `<span class="char">${ch}</span>`
      ).join('');
    });

    const tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
    const heroMeta = $('.hero-meta');
    if (heroMeta) {
      tl.fromTo('.hero-meta', { opacity: 0, y: 16, filter: 'blur(6px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7 });
    }
    tl.fromTo('.hero h1 .char',
      { opacity: 0, y: '100%', rotateX: -90 },
      { opacity: 1, y: '0%', rotateX: 0, duration: 0.6, stagger: { amount: 0.5, from: 'start' }, transformOrigin: 'bottom center' }, '-=0.3'
    )
    .fromTo('.hero-sub',
      { clipPath: 'inset(0 100% 0 0)', opacity: 1 },
      { clipPath: 'inset(0 0% 0 0)', duration: 0.9, ease: 'power3.inOut' }, '-=0.2'
    )
    .fromTo('.hero-actions .btn',
      { opacity: 0, scale: 0.88, y: 16 },
      { opacity: 1, scale: 1, y: 0, duration: 0.5, stagger: 0.1 }, '-=0.3'
    )
    .fromTo('.hero-stat',
      { opacity: 0, x: 40 },
      { opacity: 1, x: 0, duration: 0.5, stagger: 0.12 }, '-=0.4'
    )
    .fromTo('.hero-scroll', { opacity: 0 }, { opacity: 1, duration: 0.6 }, '-=0.2');
  }

  // ── Magnetic buttons ──
  $$('.btn-yellow, .btn-ghost').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      gsap.to(btn, { x: x * 0.25, y: y * 0.25, duration: 0.3, ease: 'power2.out' });
    });
    btn.addEventListener('mouseleave', () => {
      gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.4)' });
    });
  });

  if (typeof ScrollTrigger === 'undefined') return;

  // ── Scroll-triggered animations ──
  const scrollAnims = [
    { sel: '.svc-card',         from: { clipPath: 'inset(0 0 100% 0)', opacity: 1 }, to: { clipPath: 'inset(0 0 0% 0)', duration: 0.9, stagger: 0.15, ease: 'power3.inOut' }, trigger: '.services-teaser', start: 'top 78%' },
    { sel: '.stats-bar .stat',  from: { opacity: 0, y: 30, scale: 0.9 }, to: { opacity: 1, y: 0, scale: 1, duration: 0.65, stagger: 0.1, ease: 'back.out(1.7)' }, trigger: '.stats-bar', start: 'top 82%' },
    { sel: '.col-card',         from: { opacity: 0, y: 50, rotate: 1.5 }, to: { opacity: 1, y: 0, rotate: 0, duration: 0.7, stagger: 0.1, ease: 'power3.out' }, trigger: '.collections-strip', start: 'top 80%' },
    { sel: '.product-card',     from: { opacity: 0, y: 40, scale: 0.95 }, to: { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.1, ease: 'back.out(1.3)' }, trigger: '.product-grid', start: 'top 80%' },
    { sel: '.cta-banner',       from: { opacity: 0, scaleY: 0.92 }, to: { opacity: 1, scaleY: 1, duration: 0.8, ease: 'expo.out', transformOrigin: 'center center' }, trigger: '.cta-banner', start: 'top 82%' },
    { sel: '.testimonial-card', from: { opacity: 0, y: 35, rotate: -1 }, to: { opacity: 1, y: 0, rotate: 0, duration: 0.65, stagger: 0.08, ease: 'power2.out' }, trigger: '.testimonial-grid', start: 'top 82%' },
    { sel: '.faq-list .faq-item', from: { opacity: 0, x: -30 }, to: { opacity: 1, x: 0, duration: 0.5, stagger: 0.07, ease: 'power2.out' }, trigger: '.faq-list', start: 'top 82%' },
    { sel: '.pkg-card',         from: { opacity: 0, y: 40 }, to: { opacity: 1, y: 0, duration: 0.6, stagger: 0.1, ease: 'power3.out' }, trigger: '.pkg-grid', start: 'top 80%' },
    { sel: '.coating-card',     from: { opacity: 0, y: 50, scale: 0.97 }, to: { opacity: 1, y: 0, scale: 1, duration: 0.7, stagger: 0.12, ease: 'power2.out' }, trigger: '.coating-grid', start: 'top 80%' },
    { sel: '.step',             from: { opacity: 0, x: -30 }, to: { opacity: 1, x: 0, duration: 0.6, stagger: 0.1, ease: 'power2.out' }, trigger: '.steps', start: 'top 82%' },
    { sel: '.gimg',             from: { opacity: 0, scale: 0.94 }, to: { opacity: 1, scale: 1, duration: 0.7, stagger: 0.08, ease: 'power2.out' }, trigger: '.gallery', start: 'top 82%' },
    { sel: '.includes-grid li', from: { opacity: 0, x: -16 }, to: { opacity: 1, x: 0, duration: 0.4, stagger: 0.04, ease: 'power2.out' }, trigger: '.includes-grid', start: 'top 82%' },
    { sel: '.trust-badge',      from: { opacity: 0, y: 16 }, to: { opacity: 1, y: 0, duration: 0.4, stagger: 0.07, ease: 'power2.out' }, trigger: '.trust-row', start: 'top 88%' },
    { sel: '.filter-group',     from: { opacity: 0, x: -20 }, to: { opacity: 1, x: 0, duration: 0.5, stagger: 0.08, ease: 'power2.out' }, trigger: '.col-sidebar', start: 'top 80%' },
  ];

  scrollAnims.forEach(a => {
    if (!$(a.trigger) || !$$(a.sel).length) return;
    gsap.fromTo(a.sel, a.from, { ...a.to, scrollTrigger: { trigger: a.trigger, start: a.start } });
  });

  // Section heads
  $$('.section-head').forEach(el => {
    const h2 = el.querySelector('h2');
    if (h2) gsap.fromTo(h2, { clipPath: 'inset(0 100% 0 0)' },
      { clipPath: 'inset(0 0% 0 0)', duration: 1, ease: 'power3.inOut',
        scrollTrigger: { trigger: el, start: 'top 82%' } });
    const eye = el.querySelector('.eyebrow');
    if (eye) gsap.fromTo(eye, { opacity: 0, x: -20 },
      { opacity: 1, x: 0, duration: 0.5, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 82%' } });
  });

  // Hero parallax on svc cards
  $$('.svc-card').forEach(card => {
    const pic = card.querySelector('.pic');
    if (!pic) return;
    gsap.to(pic, { yPercent: -12, ease: 'none',
      scrollTrigger: { trigger: card, start: 'top bottom', end: 'bottom top', scrub: 1.5 } });
  });

  // Service detail hero
  if ($('.svc-detail-hero')) {
    const tl2 = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl2.fromTo('.svc-detail-hero .eyebrow', { opacity: 0, x: -24 }, { opacity: 1, x: 0, duration: 0.6 })
      .fromTo('.svc-detail-hero h1 span', { opacity: 0, y: 60, skewY: 3 },
        { opacity: 1, y: 0, skewY: 0, duration: 0.8, stagger: 0.14 }, '-=0.3')
      .fromTo('.svc-detail-hero p', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.3')
      .fromTo('.svc-detail-hero .row', { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.5 }, '-=0.2');
    gsap.fromTo('.book-aside', { opacity: 0, x: 40 },
      { opacity: 1, x: 0, duration: 0.8, ease: 'power3.out',
        scrollTrigger: { trigger: '.detail-layout', start: 'top 75%' } });
    gsap.utils.toArray('.detail-content h2').forEach(el => {
      gsap.fromTo(el, { opacity: 0, clipPath: 'inset(0 100% 0 0)' },
        { opacity: 1, clipPath: 'inset(0 0% 0 0)', duration: 0.9, ease: 'power3.inOut',
          scrollTrigger: { trigger: el, start: 'top 85%' } });
    });
  }

  // Services hero
  if ($('.svc-hero')) {
    const tl3 = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl3.fromTo('.svc-hero .eyebrow', { opacity: 0, x: -24 }, { opacity: 1, x: 0, duration: 0.6 })
      .fromTo('.svc-hero h1 span', { opacity: 0, y: 60, skewY: 3 },
        { opacity: 1, y: 0, skewY: 0, duration: 0.75, stagger: 0.12 }, '-=0.3')
      .fromTo('.svc-hero p', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.3')
      .fromTo('.svc-hero .btn', { opacity: 0, y: 16, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 0.5, stagger: 0.1 }, '-=0.2');
  }

  // Collection hero
  if ($('.col-hero')) {
    const tl4 = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl4.fromTo('.col-hero h1', { opacity: 0, y: 50, clipPath: 'inset(0 100% 0 0)' },
      { opacity: 1, y: 0, clipPath: 'inset(0 0% 0 0)', duration: 0.9 })
      .fromTo('.col-hero-meta span', { opacity: 0, y: 12 },
        { opacity: 1, y: 0, duration: 0.5, stagger: 0.08 }, '-=0.4')
      .fromTo('.col-hero p', { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3');
  }

  // Product page
  if ($('.pd-images')) {
    const tl5 = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl5.fromTo('.pd-images', { opacity: 0, x: -40 }, { opacity: 1, x: 0, duration: 0.8 })
      .fromTo('.pd-info > *', { opacity: 0, y: 28 },
        { opacity: 1, y: 0, duration: 0.6, stagger: 0.08 }, '-=0.5');
  }
});
